<script>
  import { createEventDispatcher } from "svelte";
  import CustomIcon from "../CustomIcon.svelte";
  export let active = false;
  export let label = { on: "Deactivate", off: "Activate" };
  export let colors = { on: "#009834", off: "#B2833F" };
  export let disabled = false;
  export let size = 18;
  export let viewBox = `0 0 22 ${size*(2/3)}`;
  const dispatch = createEventDispatcher();
  export let click = (e) => {
    dispatch(e.type);
  };
  $: toggle = `toggle_${active ? "on" : "off"}`;
  $: toggleLabel = label[active ? "on" : "off"];
  $: toggleColors = colors[active ? "on" : "off"];
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<span on:click|preventDefault={click}>
  <CustomIcon
    {disabled}
    name={toggle}
    label={toggleLabel}
    color={toggleColors}
    height={size}
    width={size}
    viewBox={viewBox}
  />
</span>
